export default {
  equalsIgnoringCase (text: string, other: string) {
    return text ? text.localeCompare(other, undefined, { sensitivity: 'accent' }) === 0 : false
  },
	toLowerCaseAndTrim(text: string) {
		return text ? text.toLowerCase().trim() : text;
	},
	toLowerCaseAndTrimAndRemoveAllSpaces(text: string) {
		return text ? text.toLowerCase().trim().replace(' ', '') : text;
	}
}
